/**
 * `commandVisitor` is an abstract visitor for a command
 * (cf. http://en.wikipedia.org/wiki/Visitor_pattern).
 */

/**
 * Todo: Add JSDoc comment
 */
function commandVisitor() {
	const that = {};

	that.visit = function (aCommand) {
		return aCommand.accept(that);
	};

	that.visitAll = function (aCollection) {
		return aCollection.map((each) => that.visit(each));
	};

	that.visitCommand = function (_aCommand) {};

	that.visitCreateDirectoryCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitDeleteDirectoryCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitDownloadCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitExportCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitMarkAsPreliminaryCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitEditEntryPermissionsCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitMoveCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitRenameCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitUploadCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitMultipleUploadCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitImportCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitAgencyImportCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	that.visitNotifyUsersCommand = function (aCommand) {
		return that.visitCommand(aCommand);
	};

	return that;
}

export default commandVisitor;
